import { render } from "./GlobalError.vue?vue&type=template&id=0d2c453e"
import script from "./GlobalError.vue?vue&type=script&lang=js"
export * from "./GlobalError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__